/** @format */

import {MouseEvent, ReactNode} from 'react';

import {Box, Checkbox, IconButton, Typography} from '@mui/material';

import {Construction} from '@mui/icons-material';

import {CheckboxRowRoot as Root, checkboxRowClasses as classes} from './style';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  onRemove?: () => void;
  label: string;
  disabled?: boolean;
  isStub?: boolean;
  categoryIcon?: ReactNode;
}

const CheckboxRow = ({
  checked,
  disabled,
  label,
  onRemove,
  onChange,
  isStub,
  categoryIcon,
}: Props) => {
  const closeImg = new URL('../../images/close.svg', import.meta.url).href;

  const handleClick = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (disabled) return;
    onChange(!checked);
  };

  const handleRemove = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (disabled || !onRemove) return;
    onRemove();
  };

  return (
    <Root>
      <Box className={classes.clickableArea} onClick={handleClick}>
        <Checkbox
          checked={checked}
          onChange={() => {}}
          disableTouchRipple
          disabled={disabled}
          className={classes.checkbox}
        />
        <Box className={classes.labelArea}>
          <Typography className={classes.label}>{label}</Typography>
          {categoryIcon}
        </Box>
      </Box>

      {isStub && (
        <Box className={classes.badge}>
          <Construction sx={{fontSize: 16, color: '#F9FCFE'}} />
        </Box>
      )}

      {onRemove && (
        <IconButton
          disableRipple
          onClick={handleRemove}
          className={classes.removeButton}
          disabled={disabled}
        >
          <img src={closeImg} alt='X' />
        </IconButton>
      )}
    </Root>
  );
};

export default CheckboxRow;
